const primeColor = "#35a047";
const primeColorLight = "#F4F9F3";
const textGrey = "rgba(0,0,0,0.6)";
const lightGrey = "#f3f9fd";

export { primeColor, primeColorLight, textGrey, lightGrey };
